import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CreateOrEditEventTypeDto, RegistrationsServiceProxy, DisapproveRegistrationInput, RegistrationDto, } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'disapproveModal',
    templateUrl: './disapprove-modal.component.html'
})

export class  DisapproveModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal') modal: ModalDirective;    
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    
    registration: RegistrationDto = new RegistrationDto();
    note = undefined;

    constructor(
        injector: Injector,
        private _registrationsService: RegistrationsServiceProxy
        
    ) {
        super(injector);        
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }
    
    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();        
    }    

    public show(registration: RegistrationDto): void {        
        
        this.active = true;        
        this.registration = registration;  
        this.note = undefined;      
        this.modal.show();
    }    

    save(): void {
        
        let msg = this.l('Are you sure disapprove the registration of the {0}?', this.registration.user.name);
    
        let input = new DisapproveRegistrationInput()
        input.registrationId = this.registration.id;
        input.note = this.note;
    
        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {
                    
                    this._registrationsService.disapprove(input)
                    .subscribe(() => {
                        this.notify.info(this.l('SavedSuccessfully'));
                        this.close();
                        this.modalSave.emit(null);
                    });
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/event/registrations/modals/disapprove/disapprove-modal.component.ts